import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Route, Switch, useLocation } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import { lazy, Suspense, useEffect } from "react";
import { trackPageView } from "./hooks/useAnalytics";

// Route-level code splitting — each page loads only when navigated to
const Home = lazy(() => import("./pages/Home"));
const AfffLitigation = lazy(() => import("./pages/AfflLitigation"));
const TurnoutGearLitigation = lazy(() => import("./pages/TurnoutGearLitigation"));
const HowToFile = lazy(() => import("./pages/HowToFile"));
const About = lazy(() => import("./pages/About"));
const FAQ = lazy(() => import("./pages/FAQ"));
const Contact = lazy(() => import("./pages/Contact"));
const NotFound = lazy(() => import("./pages/NotFound"));
const TrainingFacilities = lazy(() => import("./pages/TrainingFacilities"));
const StatePFASLaws = lazy(() => import("./pages/StatePFASLaws"));

function Router() {
  const [location] = useLocation();

  useEffect(() => {
    trackPageView(location, document.title);
  }, [location]);

  return (
    <Suspense fallback={
      <div className="min-h-screen bg-brand-black flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-brand-red border-t-transparent rounded-full animate-spin" aria-label="Loading" />
      </div>
    }>
      <Switch>
        <Route path="/" component={Home} />
        <Route path="/afff-litigation" component={AfffLitigation} />
        <Route path="/turnout-gear-litigation" component={TurnoutGearLitigation} />
        <Route path="/how-to-file" component={HowToFile} />
        <Route path="/about" component={About} />
        <Route path="/faq" component={FAQ} />
        <Route path="/contact" component={Contact} />
        <Route path="/pfas-training-facilities" component={TrainingFacilities} />
        <Route path="/pfas-state-laws" component={StatePFASLaws} />
        <Route path="/404" component={NotFound} />
        <Route component={NotFound} />
      </Switch>
    </Suspense>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider defaultTheme="dark">
        <TooltipProvider>
          <Toaster />
          <Router />
        </TooltipProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
